var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinear(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_63929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2671 10.3997V17.2669H0.733887V10.3997H19.2671ZM1.76709 16.2337H3.23389V13.7337H4.26709V16.2337H4.8999V14.5667H5.93311V16.2337H6.56689V12.0667H7.6001V16.2337H8.23389V14.5667H9.26709V16.2337H9.8999V13.7337H10.9331V16.2337H11.5669V14.5667H12.6001V16.2337H13.2339V12.0667H14.2671V16.2337H14.8999V14.5667H15.9331V16.2337H16.5669V13.7337H17.6001V16.2337H18.2339V11.4329H1.76709V16.2337ZM3.43311 3.73372V4.56673H16.5669V3.73372H19.2671V6.43294H16.5669V5.59993H3.43311V6.43294H0.733887V3.73372H3.43311ZM17.6001 5.39973H18.2339V4.76692H17.6001V5.39973ZM1.76709 5.39973H2.3999V4.76692H1.76709V5.39973Z",
    fill: "#20C3FF",
    stroke: "#20C3FF",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_63929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.3dde59c99755779ce44610c30ac3ff62.svg";
export { ForwardRef as ReactComponent };